import { render, staticRenderFns } from "./ReturKonsumen.vue?vue&type=template&id=97abadec"
import script from "./ReturKonsumen.vue?vue&type=script&lang=js"
export * from "./ReturKonsumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports